export enum GhostPracticeCodeTypes {
	FEE = 'FEE',
	DISBURSEMENT = 'DISBURSEMENT',
	FEE_AND_DISBURSEMENT = 'FEE_AND_DISBURSEMENT',
	NA = 'N/A',
}

export interface GhostPracticeCode {
	id: string;
	description: string;
	glAccount: string;
	taxApplies: boolean;
	type?: GhostPracticeCodeTypes;
}
